






import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import List from '@/components/list'
import { ListType } from '@/util/types'

@Component({
  components: {
    List
  }
})
export default class CourseMy extends ViewBase {
  listType = ListType.myCourse
}
